
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/friendbuy-alternative",
      function () {
        return require("private-next-pages/friendbuy-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/friendbuy-alternative"])
      });
    }
  